import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { SG_UPLOAD_TIMEOUT_MS } from '../../../core/constants/sg';
import { sgKeys } from '../queries/keys';
import { sgPaths } from '../queries/paths';

// TSS vite/03 — subida del backup .zip de Software Ganadero (admin-sg.md). El
// historial de backups NO es del usuario final (operación interna); solo se
// conserva la ACCIÓN de subir (gated sg:write). El .zip va como BODY BINARIO CRUDO
// — NO multipart: envolvemos el File en un Blob con MIME normalizado a
// application/zip (en Windows el File llega como application/x-zip-compressed o
// vacío). El sniffer de api.js deriva el Content-Type de blob.type; vite/04 [RIGID]
// prohíbe fijarlo a mano. query (filename/sg_codfin) por params; timeout amplio
// porque el POST corre las 3 fases del pipeline síncronamente. Sin toasts aquí.
export function useUploadBackup() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ file, sgCodfin, onProgress, signal }) => {
            const body = new Blob([file], { type: 'application/zip' });
            return api.post(sgPaths.backups(), body, {
                params: { filename: file.name, ...(sgCodfin ? { sg_codfin: sgCodfin } : {}) },
                onUploadProgress: onProgress,
                signal,
                timeout: SG_UPLOAD_TIMEOUT_MS,
            }).then(r => r.data);
        },
        onSuccess: () => qc.invalidateQueries({ queryKey: sgKeys.all }),
    });
}
